import { useEffect, useState, useCallback } from 'react'
import { atom, useAtom, getDefaultStore } from 'jotai'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import useCloneRequestController from './useCloneRequestController'
import useReservice from '../../../../../hooks/useReservice'
import { fetchBrands } from '../../../../../actions/serviceActions/proposal'
import { normalizeBrandsFromPayload, resolveBrandId } from '../helpers'

const brandsAtom = atom([])
const brandsLoadStartedAtom = atom(false)

const useBrands = () => {
  const { fetchWithAbort } = useCloneRequestController()
  const { reservice } = useReservice(fetchWithAbort)
  const [brands, setBrands] = useAtom(brandsAtom)
  const [loadStarted, setLoadStarted] = useAtom(brandsLoadStartedAtom)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (getDefaultStore().get(brandsLoadStartedAtom)) {
      return
    }

    setLoadStarted(true)
    const load = async () => {
      setIsLoading(true)
      const [err, result] = await safeAwait(reservice(fetchBrands()))
      setIsLoading(false)
      if (err) {
        return
      }

      const list = normalizeBrandsFromPayload(result)
      setBrands(list)
    }
    load()
  }, [loadStarted, reservice, setBrands, setLoadStarted])

  const getBrandIdByName = useCallback((name) => {
    return resolveBrandId(brands, name)
  }, [brands])

  return {
    isLoading,
    data: brands,
    getBrandIdByName
  }
}

export default useBrands
export { brandsAtom, brandsLoadStartedAtom } // for test reset
